// True when the page is running as an installed app rather than a browser tab.
//
// Two callers, for opposite reasons: the install banner hides itself here, and
// the sign-in wrapper switches to redirect here, because signInWithPopup cannot
// complete in a standalone window.
//
// display-mode: standalone covers Android and modern iOS. navigator.standalone
// is the older iOS-only flag, kept because iOS honoured it long before it
// supported the media query.
export default function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    window.matchMedia("(display-mode: minimal-ui)").matches ||
    window.navigator.standalone === true
  );
}
